import { useEffect, useRef } from 'react';
import { tracker } from '..';

type UseProductReviewsViewedMonitorArgs = {
  productId?: string | null;
  reviewCount: number;
  avgRating?: number | null;
  hasAiSummary: boolean;
  /** The section renders nothing until the rating summary has loaded. */
  enabled: boolean;
};

/**
 * Fires productReviewsViewed when a product's reviews section is shown, plus
 * productReviewAiSummaryViewed when that section includes an AI-generated summary.
 * Fires once per productId.
 */
export const useProductReviewsViewedMonitor = ({
  productId,
  reviewCount,
  avgRating,
  hasAiSummary,
  enabled,
}: UseProductReviewsViewedMonitorArgs): void => {
  const firedForProductId = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || !productId || firedForProductId.current === productId) {
      return;
    }
    firedForProductId.current = productId;

    tracker.productReviewsViewed({ productId, reviewCount, avgRating, hasAiSummary });

    if (hasAiSummary) {
      tracker.productReviewAiSummaryViewed({ productId });
    }
  }, [enabled, productId, reviewCount, avgRating, hasAiSummary]);
};
